'use client';

import { getClientApplicationConfig } from '@hc-frontend/core-context';
import { useEffect } from 'react';

import { useExperiments } from '../../hooks/use-experiments/use-experiments';

type UserWayApi = {
  widgetOpen: () => void;
};

type UserWayInitCompletedDetail = {
  userWayInstance: {
    iconVisibilityOff: () => void;
  };
};

function UserwayButton() {
  const config = getClientApplicationConfig();

  useEffect(() => {
    const listener = (e: unknown) => {
      const detail = (e as CustomEvent<UserWayInitCompletedDetail>).detail;
      detail?.userWayInstance?.iconVisibilityOff();
    };

    document.addEventListener('userway:init_completed', listener);

    return () => {
      document.removeEventListener('userway:init_completed', listener);
    };
  }, []);

  const handleClick = () => {
    const userWay = (window as unknown as { UserWay?: UserWayApi }).UserWay;
    if (userWay) {
      userWay.widgetOpen();
    }
  };

  return (
    <button
      className="bg-[#46bcff] w-fit rounded-full hover:scale-105 active:scale-95 transition-transform"
      aria-label="Open accessibility options"
      aria-haspopup="dialog"
      onClick={handleClick}
      type="button"
    >
      <img
        alt="accessibility icon"
        aria-hidden="true"
        src={`${config.assets.marketplaceStaticBaseUrl}/marketplace/images/userway_logo.svg`}
        width={48}
        height={48}
      />
    </button>
  );
}

export function UserwayCustomTrigger() {
  const { mp_2461_userway_widget_footer } = useExperiments();

  if (mp_2461_userway_widget_footer === 'variant') {
    return <UserwayButton />;
  }

  return null;
}
